const isFunction = (functionToCheck) => (
  functionToCheck && {}.toString.call(functionToCheck) === '[object Function]'
);

export default isFunction;